import { useEffect } from 'react';

export default function NotFound() {
    useEffect(() => {
        // Signal to react-snap and crawlers that this is a 404 page
        if (typeof document !== 'undefined') {
            const meta = document.createElement('meta');
            meta.name = 'prerender-status-code';
            meta.content = '404';
            document.head.appendChild(meta);

            const robots = document.querySelector('meta[name="robots"]');
            if (robots) {
                robots.setAttribute('content', 'noindex, nofollow');
            } else {
                const r = document.createElement('meta');
                r.name = 'robots';
                r.content = 'noindex, nofollow';
                document.head.appendChild(r);
            }
        }
    }, []);

    return (
        <div className="min-h-screen bg-[#FBF7EE] flex items-center justify-center px-4" data-testid="not-found">
            <div className="max-w-lg text-center">
                <p className="text-sm font-semibold text-[#4CAF50] mb-3 tracking-wider uppercase">Fout 404</p>
                <h1 className="text-4xl sm:text-5xl font-bold text-[#3D3B00] font-['Outfit'] mb-4 tracking-tight">
                    Pagina niet gevonden
                </h1>
                <p className="text-base text-[#3D3B00]/70 mb-8">
                    De pagina die u zoekt bestaat niet. Ga terug naar de calculator om uw voordeel te berekenen.
                </p>
                <a
                    href="/"
                    className="inline-block px-6 py-3 bg-[#4CAF50] text-white font-semibold rounded-lg hover:bg-[#43A047] transition-colors"
                    data-testid="notfound-home-btn"
                >
                    Terug naar de calculator
                </a>
            </div>
        </div>
    );
}
